import React, {useEffect, useState} from 'react';
import {Button, Card, Col, Descriptions, Icon, notification, Pagination, Row, Table, Tooltip} from 'antd';
import Spinner from "../../../spinner";
import ModalCreateStaffUser from "../../../modals/user/create-staff-user";
import ModalEditStaffUser from "../../../modals/user/edit-staff-user";
import {tableHelper} from "../../../../helpers";
import {roleService, userServices} from "../../../../services";
import './user-list.css';
import ModalEditCarrierUser from "../../../modals/user/edit-carrier-user";
import i18n from "../../../../i18n";

export default function UserList() {

  const [searchText, setSearchText] = useState('');
  const [listStaffRoles, setListStaffRoles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isNeedUpdateList, setIsNeedUpdateList] = useState(true);
  const [errorMsg, setErrorMsg] = useState(null);
  const [usersList, setUsersList] = useState([]);
  const [showModalCreate, setShowModalCreate] = useState(false);
  const [showModalEdit, setShowModalEdit] = useState(null);
  const [isStaffUser, setIsStaffUser] = useState(true);
  const [params, setParams] = useState(null);
  const [pagination, setPagination] = useState({
    defaultPageSize: 50,
    pageSize: 50,
    position: "both"
  });
  const [currentUserData, setCurrentUserData] = useState({
    fio: '',
    login: ' ',
    password: null,
    email: '',
    phone: '',
    role: '',
    status: '',
    distributionsCentersIds: [],
  });

  const [columns, setColumns] = useState([
    {
      title: i18n.t('settingsPage.userList.table.fio.title'),
      dataIndex: 'fio',
      key: 'fio',
      sorter: (a, b) => a.fio.length - b.fio.length,
      ...tableHelper.getColumnSearchProps('fio', searchText, setSearchText)
    },
    {
      title: i18n.t('settingsPage.userList.table.role.title'),
      dataIndex: 'role',
      key: 'role',
      filters: listStaffRoles,
      //...tableHelper.getColumnSearchProps('role', searchText, setSearchText),
    },
    {
      title: i18n.t('settingsPage.userList.table.email.title'),
      dataIndex: 'email',
      key: 'email',
      width: '15%',
      ...tableHelper.getColumnSearchProps('email', searchText, setSearchText)
    },
    {
      title: i18n.t('settingsPage.userList.table.phone.title'),
      dataIndex: 'phone',
      key: 'phone',
      width: '15%',
      ...tableHelper.getColumnSearchProps('phone', searchText, setSearchText)
    },
    {
      title: i18n.t('settingsPage.userList.table.status.title'),
      dataIndex: 'status',
      key: 'status',
      filters: [{text: i18n.t('settingsPage.userList.table.status.values.active'), value: '10'}, {text: i18n.t('settingsPage.userList.table.status.values.deleted'), value: '0'}],
      width: '15%'
    },
    {
      title: null,
      key: 'edit',
      width: '120px',
      render: (data) => {

        if (data.isStaffUser) {

          return (
            <React.Fragment>
              <Button type="primary" icon={"edit"} htmlType="button" onClick={() => {
                setShowModalEdit(data.id);
                setCurrentUserData(data);
                setIsStaffUser(data.isStaffUser);
              }}
                      size="small" style={smallButtonStyle}/>
            </React.Fragment>
          );

        } else {
          return (
            <React.Fragment>
              <Button type="primary" htmlType="button" onClick={() => {
                setShowModalEdit(data.id);
                setCurrentUserData(data);
                setIsStaffUser(data.isStaffUser);
              }}
                      size="small" style={smallButtonStyle}>
                {i18n.t('settingsPage.userList.buttons.edit')}
              </Button>
            </React.Fragment>
          );
        }
      }
    },
  ]);

  let smallButtonStyle = {
    width: '60px',
    height: '40px',
    background: '#1CAA53',
    position: 'static',
    borderRadius: '10px',
    color: "white",
    borderColor: "transparent"
  };
  let addUserButton = {
    width: "100%",
    maxWidth: '270px',
    height: '43px',
    background: '#1CAA53',
    position: 'static',
    borderRadius: '10px',
    color: "white",
    borderColor: "transparent"
  };

  const getUserList = (params) => {
    setLoading(true);
    userServices.getUsersList({...params})
      .then((res) => {
        const usersData = res.users.map((item) => {
          return {
            id: item.id,
            fio: item.fio,
            login: item.login,
            email: item.email,
            phone: item.phone,
            roleName: item.role.name,
            role: item.role.description,
            statusName: item.status.name,
            status: item.status.description === 'Активен'? i18n.t('settingsPage.userList.table.status.values.active') : i18n.t('settingsPage.userList.table.status.values.deleted'),
            distributionsCenters: item.distributionsCenters,
            isStaffUser: item.isStaffUser,
            isAccreditedIntDeliveries: item.isAccreditedIntDeliveries,
            delivDisplayDelay: item.delivDisplayDelay,
          };
        });

        setPagination({
          ...pagination,
          total: res.totalCount
        });

        setIsNeedUpdateList(false);
        setLoading(false);
        setUsersList(usersData);
      })
      .catch((errorMsg) => {
        setIsNeedUpdateList(false);
        setLoading(false);
        setErrorMsg(errorMsg);
      });
  };

  useEffect(() => {
    if (isNeedUpdateList && !params) {
      getUserList({step: pagination.pageSize, offset: 0});
    }

    if (isNeedUpdateList && params) {
      getUserList({...params});
    }

  }, [isNeedUpdateList]);

  useEffect(() => {
    roleService.getRolesForFilters()
      .then((response) => {
        const staffRolesData = response.map((roleData) => {
          return {
            value: [roleData.Name],
            text: roleData.Description,
          }
        });

        setListStaffRoles(staffRolesData);
      })
      .catch((error) => {
        notification.error({
          message: i18n.t('settingsPage.userList.notification.error.title'),
          description: error,
        });
      });
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  });

  useEffect(() => {
    handleResize();
  }, [listStaffRoles]);

  const handleResize = () => {
    if (window.innerWidth > 1023) {
      setColumns([
        {
          title: i18n.t('settingsPage.userList.table.fio.title'),
          dataIndex: 'fio',
          key: 'fio',
          sorter: (a, b) => a.fio.length - b.fio.length,
          ...tableHelper.getColumnSearchProps('fio', searchText, setSearchText),
        },
        {
          title: i18n.t('settingsPage.userList.table.role.title'),
          dataIndex: 'role',
          key: 'role',
          filters: listStaffRoles,
        },
        {
          title: i18n.t('settingsPage.userList.table.email.title'),
          dataIndex: 'email',
          key: 'email',
          width: '15%',
          ...tableHelper.getColumnSearchProps('email', searchText, setSearchText)
        },
        {
          title: i18n.t('settingsPage.userList.table.phone.title'),
          dataIndex: 'phone',
          key: 'phone',
          width: '15%',
          ...tableHelper.getColumnSearchProps('phone', searchText, setSearchText)
        },
        {
          title: i18n.t('settingsPage.userList.table.status.title'),
          dataIndex: 'status',
          key: 'status',
          filters: [{text: i18n.t('settingsPage.userList.table.status.values.active'), value: '10'}, {text: i18n.t('settingsPage.userList.table.status.values.deleted'), value: '0'}],
          width: '15%'
        },
        {
          title: null,
          key: 'edit',
          width: '60px',
          render: (data) => {

            if (data.isStaffUser) {

              return (
                <React.Fragment>
                  <Button type="primary" icon={"edit"} htmlType="button" onClick={() => {
                    setShowModalEdit(data.id);
                    setCurrentUserData(data);
                    setIsStaffUser(data.isStaffUser);
                  }}
                          size="small" style={smallButtonStyle}/>
                </React.Fragment>
              );

            } else {
              return (
                <React.Fragment>
                  <Button type="primary" icon={"edit"} htmlType="button" onClick={() => {
                    setShowModalEdit(data.id);
                    setCurrentUserData(data);
                    setIsStaffUser(data.isStaffUser);
                  }}
                          size="small" style={smallButtonStyle}/>
                </React.Fragment>
              );
            }
          }
        },
      ]);
    } else if (window.innerWidth <= 1023) {
      setColumns([
        {
          title: <><Icon type="user"/><span>{i18n.t('settingsPage.userList.table.fio.title')}</span></>,
          key: 'fio',
          width: "100%",
          sorter: (a, b) => a.fio - b.fio,
          dataIndex: "fio",
          ...tableHelper.getColumnSearchProps('fio', searchText, setSearchText),
          children: [
            {
              title: <Tooltip title={i18n.t('settingsPage.userList.table.role.title')}><><Icon type="solution"/><span>  {i18n.t('settingsPage.userList.table.role.title')}</span></>
              </Tooltip>,
              dataIndex: "role",
              filters: listStaffRoles,
              render: (text, record, index) => {
                return {
                  children: <>
                    <Card title={<b>{record.fio}</b>}
                          extra={<Icon type="edit" key="edit" onClick={() => {
                            setShowModalEdit(record.id);
                            setCurrentUserData(record);
                            setIsStaffUser(record.isStaffUser);
                          }}/>}
                          size={"small"}
                    >
                      <Descriptions column={1} size={"small"}>
                        <Descriptions.Item label={i18n.t('settingsPage.userList.table.role.title')}>{record.role}</Descriptions.Item>
                        <Descriptions.Item label={i18n.t('settingsPage.userList.table.email.title')}>{record.email}</Descriptions.Item>
                        <Descriptions.Item label={i18n.t('settingsPage.userList.table.phone.title')}>{record.phone}</Descriptions.Item>
                        <Descriptions.Item label={i18n.t('settingsPage.userList.table.status.title')}>{record.status}</Descriptions.Item>
                      </Descriptions>
                    </Card>
                  </>,
                  props: {colSpan: 4}
                }
              },
            },
            {
              title: <Tooltip title={i18n.t('settingsPage.userList.table.status.title')}><><Icon type="info-circle"/><span>  Статус</span></>
              </Tooltip>,
              dataIndex: "status",
              filters: [{text: i18n.t('settingsPage.userList.table.status.values.active'), value: '10'}, {text: i18n.t('settingsPage.userList.table.status.values.deleted'), value: '0'}],
              render: () => {
                return null
              }
            }
          ]
        },
        {//TODO проверить - текст в файле, отправленном для перевода, отличается
          title: <Tooltip title={i18n.t('settingsPage.userList.table.date.title')}><><Icon type="calendar"/><span>  {i18n.t('settingsPage.userList.table.date.title')}</span></>
          </Tooltip>,
          dataIndex: "created_at",
          sorter: (a, b) => a["created_at"] - b["created_at"],
          children: [
            {
              title: <Tooltip title={i18n.t('settingsPage.userList.table.email.title')}><><Icon type="mail"/><span>  {i18n.t('settingsPage.userList.table.email.title')}</span></>
              </Tooltip>,
              dataIndex: "email",
              ...tableHelper.getColumnSearchProps('email', searchText, setSearchText),
              render: () => {
                return null
              }
            },
            {
              title: <Tooltip title={i18n.t('settingsPage.userList.table.phone.title')}><><Icon type="phone"/><span> {i18n.t('settingsPage.userList.table.phone.title')}</span></>
              </Tooltip>,
              dataIndex: "phone",
              ...tableHelper.getColumnSearchProps('phone', searchText, setSearchText),
              render: () => {
                return null
              }
            },
          ]
        }
      ]);
    }
  };

  if (errorMsg) {
    return (<div className="content-error-block">{errorMsg}</div>);
  }

  const onTableChange = (pagination, filters, sorter) => {
    setPagination({
      ...pagination
    });

    const params = {
      offset: (pagination.current - 1) * pagination.pageSize,
      step: pagination.pageSize,
      orderBy: sorter.order && sorter.columnKey === 'fio' ?
        'name' :
        sorter.order ? sorter.field : '',
      isSortASC: Boolean(sorter.order === 'ascend'),
      ...filters
    };

    setParams(params);

    getUserList({...params});
  }

  return (
    <React.Fragment>
      <h1 className="content-header" style={{marginBottom: 5}}>{i18n.t('settingsPage.userList.title')}</h1>
      <Spinner loading={loading} label={null}>
        <Row type="flex" justify="end">
          <Col span={4} className="btn-create-entity-block">
            <Button htmlType='button' type="primary" style={addUserButton} onClick={() => setShowModalCreate(true)}>
              {i18n.t('settingsPage.userList.buttons.create')}
            </Button>
            <ModalCreateStaffUser
              onCloseModal={() => {
                setShowModalCreate(false);
                setLoading(true);
                setIsNeedUpdateList(true);
              }}
              isShow={showModalCreate}
            />
          </Col>
        </Row>
        <Col span={24}>
          <Table
            columns={columns}
            dataSource={usersList}
            loading={loading}
            locale={{emptyText: i18n.t('settingsPage.userList.empty')}}
            rowKey="id"
            size="small"
            pagination={pagination}
            onChange={onTableChange}
            className="app-table app-table--with-card-mobile"
          />
          <ModalEditStaffUser
            isShow={(showModalEdit !== null && isStaffUser)}
            onCloseModal={() => {
              setShowModalEdit(null);
              setLoading(true);
              setIsNeedUpdateList(true);
              setCurrentUserData({
                fio: '',
                login: ' ',
                password: null,
                email: '',
                phone: '',
                role: '',
                status: '',
                distributionsCentersIds: [],
              });
            }}
            currentUserData={{
              fio: currentUserData.fio,
              login: currentUserData.login,
              password: null,
              email: currentUserData.email,
              phone: currentUserData.phone,
              role: currentUserData.roleName,
              status: currentUserData.statusName,
              distributionsCentersIds: currentUserData.distributionsCentersIds,
            }}
            userId={showModalEdit}
          />
          <ModalEditCarrierUser
            isShow={(showModalEdit !== null && !isStaffUser)}
            onCloseModal={() => {
              setShowModalEdit(null);
              setLoading(true);
              setIsNeedUpdateList(true);
            }}
            userId={currentUserData.id}
            userStatus={currentUserData.statusName}
            userFio={currentUserData.fio}
            delivDisplayDelay={currentUserData.delivDisplayDelay}
            userAccreditedIntDeliveries={currentUserData.isAccreditedIntDeliveries}
            roleName={currentUserData.roleName}
          />
        </Col>
      </Spinner>
    </React.Fragment>
  );
}
